import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconOptions = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_3001_1412)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M15.5625 9.375C15.5625 10.166 14.9473 10.7812 14.1562 10.7812C13.3652 10.7812 12.75 10.166 12.75 9.375C12.75 8.58398 13.3652 7.96875 14.1562 7.96875C14.9473 7.96875 15.5625 8.58398 15.5625 9.375ZM10.4062 9.375C10.4062 10.166 9.79102 10.7812 9 10.7812C8.20898 10.7812 7.59375 10.166 7.59375 9.375C7.59375 8.58398 8.20898 7.96875 9 7.96875C9.79102 7.96875 10.4062 8.58398 10.4062 9.375ZM3.84375 10.7812C3.05273 10.7812 2.4375 10.166 2.4375 9.375C2.4375 8.58398 3.05273 7.96875 3.84375 7.96875C4.63477 7.96875 5.25 8.58398 5.25 9.375C5.25 10.166 4.63477 10.7812 3.84375 10.7812Z",
			fill: "currentColor"
		})
	})
});
export default SvgIconOptions;
